import { Outlet } from 'react-router-dom';

function Solicitudes() {
  return <Outlet />;
}

export default Solicitudes;
